import { render, staticRenderFns } from "./ProductArtworks.vue?vue&type=template&id=5a95e7b2&"
import script from "./ProductArtworks.vue?vue&type=script&lang=js&"
export * from "./ProductArtworks.vue?vue&type=script&lang=js&"
import style0 from "./ProductArtworks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports